<template>
  <form id="mainForm" action="#" method="post">
    <Card>
      <template #title>
        <Toolbar>
          <template #left>
            <div class="p-card-title">[{{ mode }}] {{ $t("agt") }}</div>
            <div
              style="margin-left: 10px"
              v-if="mode != this.$FORM_MODE_CREATE"
            >
              <Button
                type="button"
                icon="pi pi-info"
                @click="toggle"
                aria:haspopup="true"
                aria-controls="overlay_panel"
                class="p-button-rounded p-button-outlined p-button-sm"
              />

              <OverlayPanel
                ref="op"
                appendTo="body"
                :showCloseIcon="true"
                id="overlay_panel"
                style="width: 550px"
                :breakpoints="{ '960px': '80vw' }"
              >
                <div class="grid field">
                  <div class="row">
                    <i class="pi pi-plus-circle" />
                    {{ this.$formatDateTime(header.CreatedDate) }}
                  </div>
                  <div class="row">&nbsp;by {{ header.CreatedBy }}</div>
                </div>
                <div class="grid field" v-if="header.EditedDate">
                  <div class="row">
                    <i class="pi pi-pencil" />
                    {{ this.$formatDateTime(header.EditedDate) }}
                  </div>
                  <div class="row">&nbsp;by {{ header.EditedBy }}</div>
                </div>
              </OverlayPanel>
            </div>
          </template>

          <template #right>
            <Button
              icon="pi pi-chevron-left"
              :label="$t('back')"
              class="p-button mr-2"
              @click="backToIndex"
            />
            <Button
              icon="pi pi-save"
              :label="$t('save')"
              class="p-button-success"
              @click="confirm($event)"
              v-if="mode != this.$FORM_MODE_VIEW"
            />
            <ConfirmPopup></ConfirmPopup>
          </template>
        </Toolbar>
      </template>
      <template #content>
        <div class="p-inputtext-sm p-fluid">
          <FormField
            :labelName="$t('user')"
            fieldName="UserId"
            v-model="header"
          >
            <CustomSelect
              class="p-inputtext-sm"
              v-model="header.UserId"
              v-if="header"
              :url="this.$API_URL + 'list/userbycompany'"
              :minLength="0"
              :filter="true"
              :params="{ companyId: this.companyId }"
              @change="changeUser($event)"
              :class="{ 'p-invalid': submitted && !header.UserId }"
              :disabled="this.mode != this.$FORM_MODE_CREATE"
            />
            <small
              v-if="
                header &&
                !header.UserId &&
                submitted &&
                mode != this.$FORM_MODE_DELETE
              "
              class="p-error"
              >{{ $t("is_required").replace("Value", $t("user")) }}
            </small>
            <Skeleton v-else-if="!header" />
          </FormField>

          <FormField
            :labelName="$t('username')"
            fieldName="Username"
            v-model="header"
          >
            <InputText
              name="Username"
              v-model="header.Username"
              type="text"
              :placeholder="$t('username')"
              v-if="header"
              :disabled="true"
            />
          </FormField>

          <FormField
            :labelName="$t('fullname')"
            fieldName="Fullname"
            v-model="header"
          >
            <InputText
              name="Fullname"
              v-model="header.Fullname"
              type="text"
              :placeholder="$t('fullname')"
              v-if="header"
              :disabled="true"
            />
          </FormField>

          <FormField
            :labelName="$t('email')"
            fieldName="Email"
            v-model="header"
          >
            <InputText
              name="Email"
              v-model="header.Email"
              type="text"
              :placeholder="$t('email')"
              v-if="header"
              :disabled="true"
            />
          </FormField>

          <FormField
            :labelName="$t('phone')"
            fieldName="Phone"
            v-model="header"
          >
            <InputText
              name="Phone"
              v-model="header.Phone"
              type="text"
              :placeholder="$t('phone')"
              v-if="header"
              :disabled="true"
            />
          </FormField>

          <FormField
            :labelName="$t('agt_number')"
            fieldName="AgtNumber"
            v-model="header"
          >
            <InputText
              name="AgtNumber"
              v-model="header.AgtNumber"
              type="text"
              :placeholder="$t('agt_number')"
              v-if="header"
              :disabled="false"
            />
          </FormField>

          <FormField
            :labelName="$t('valid_from')"
            fieldName="ValidFrom"
            v-model="header"
          >
            <DatePicker
              v-model="header.ValidFrom"
              dateFormat="dd/mm/yyyy"
              inputMask="99/99/9999"
              momentFormat="DD/MM/YYYY"
              class="p-inputtext-sm"
              v-if="header"
            />
          </FormField>

          <FormField
            :labelName="$t('valid_to')"
            fieldName="ValidTo"
            v-model="header"
          >
            <DatePicker
              v-model="header.ValidTo"
              dateFormat="dd/mm/yyyy"
              inputMask="99/99/9999"
              momentFormat="DD/MM/YYYY"
              class="p-inputtext-sm"
              v-if="header"
            />
          </FormField>

          <FormField
            :labelName="$t('img_agt')"
            fieldName="imgAgtModel"
            v-model="header"
          >
            <CustomFileUpload
              :fileModels="imgAgtModel"
              :multiple="false"
              :showUploadButton="false"
              :showCancelButton="false"
              :customUpload="false"
              :maxFileSize="5000000"
              accept="image/png,/image/jpg,image/jpeg,application/pdf"
              @select="onFileSelectImgAgt"
              @remove="onFileRemoveImgAgt"
            />
            <CustomFileUpload
              :fileModels="this.viewFileAgt"
              :multiple="false"
              :showUploadButton="false"
              :showCancelButton="false"
              :customUpload="false"
              @select="onFileSelectImgAgt"
              @remove="onFileRemoveImgAgt"
              :viewOnly="true"
              :showHeader="false"
              @download="onDownloadFileImgAgt"
            />
          </FormField>
        </div>
      </template>
    </Card>
  </form>
</template>

<script>
import moment from "moment";
export default {
  name: "Editor",
  data() {
    return {
      indexName: "AgtIndex",
      url: this.$API_URL + "agt/",
      companyId: this.$store.getters.getCompanyId,
      companyCode: this.$store.getters.getCompanyCode,
      imgAgtModel: [],
      viewFileAgt: [],
      header: null,
      detail: null,
      mode: "",
      id: 0,
      formEditable: true,
    };
  },
  methods: {
    getData() {
      var self = this;
      this.$axios
        .get(this.url + this.id + "/" + this.mode)
        .then((response) => {
          self.header = response.data.data.header;
          self.header.mode = self.mode;
          self.viewFileAgt = response.data.data.header.viewFilesAgtPerson;
        })
        .catch(function (error) {
          alert(error);
        });
    },
    saveData() {
      this.$emit("block-ui");
      var self = this;
      var data = new FormData();

      data.append("Id", this.header.Id);
      data.append("mode", this.header.mode);
      data.append("CompanyCode", this.companyCode);

      if (this.header.UserId != null) data.append("UserId", this.header.UserId);
      if (this.header.Username != null)
        data.append("Username", this.header.Username);
      if (this.header.Fullname != null)
        data.append("Fullname", this.header.Fullname);
      if (this.header.Email != null) data.append("Email", this.header.Email);
      if (this.header.Phone != null) data.append("Phone", this.header.Phone);
      if (this.header.AgtNumber != null)
        data.append("AgtNumber", this.header.AgtNumber);
      if (this.header.DocAssetName != null)
        data.append("DocAssetName", this.header.DocAssetName);
      if (this.header.ValidFrom != null) {
        data.append(
          "ValidFrom",
          moment(this.header.ValidFrom).format("YYYY/MM/DD").toString()
        );
      }
      if (this.header.ValidTo != null) {
        data.append(
          "ValidTo",
          moment(this.header.ValidTo).format("YYYY/MM/DD").toString()
        );
      }

      if (this.imgAgtModel.length != 0) {
        for (var x = 0; x < this.imgAgtModel.length; x++) {
          data.append(
            "attachmentsagt.File",
            this.imgAgtModel[x],
            this.imgAgtModel[x].name
          );
        }
      }

      this.$axios
        .post(this.url, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.success) {
            this.$router.push({
              name: this.indexName,
              params: {
                showToast: true,
                severity: "success",
                summary: "Data Saved",
                detail: response.data.message,
                life: 3000,
              },
            });
          } else {
            this.showError("Error Saving Data", response.data.message);
          }
        })
        .catch(function (error) {
          this.showError("Error Saving Data", error);
        });
    },
    onFileSelectImgAgt(event) {
      this.imgAgtModel = event.files;
    },
    onFileRemoveImgAgt() {
      this.imgAgtModel = [];
    },

    onDownloadFileImgAgt(file) {
      this.$emit("block-ui");
      //console.log(file)
      var self = this;
      this.$axios
        .get(this.url + "download_currently_agt/" + file.id + "/" + file.name, {
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.name);
          document.body.appendChild(link);
          link.click();
          self.$emit("unblock-ui");
        })
        .catch(function (err) {
          self.$parent.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "File not found" + err,
            life: 3000,
          });
          self.blocked = false;
          self.$emit("unblock-ui");
          //self.showAssignModal = false;
        });
    },
    changeUser(e) {
      if (e != null) {
        this.header.Username = e.username;
        this.header.Fullname = e.fullname;
        this.header.Email = e.email;
        this.header.Phone = e.phone;
      }
    },
    showError(summary, message) {
      this.$emit("unblock-ui");
      this.$toast.add({
        severity: "error",
        summary: summary,
        detail: message,
        life: 3000,
      });
    },
    backToIndex() {
      this.$router.push({ path: "/Agt/Index" });
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    confirm(event) {
      this.$confirm.require({
        target: event.currentTarget,
        message: "Are you sure?",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.saveData();
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
      });
    },
  },
  created() {
    this.mode = this.$route.query.mode;
    this.id = this.$route.query.id ?? 0;

    this.getData();
  },
};
</script>
